import React, { useSyncExternalStore } from 'react'
import {Contract ,ethers, isKeystoreJson} from "ethers"
import { useState,useEffect } from 'react'
const HealthCare = () => {
    const[isOwner,setIsOwner] =useState(null);
    const[signer,setSigner] =useState(null);
    const[provider,setProvider] =useState(null);
    const[contract,setContrat]=useState(null);
    const[account,setAccount] =useState(null);
    const [providerAddress, setProviderAddress] = useState("");
    const[patientID,setPatientID] = useState('')
    const[patientRecords,setPatientRecords]=useState([])
    const[diagnosis,setDiagnosis] =useState("");
    const [treatment,setTreatment]=useState("")
    const[patId,setPatId] = useState("");
    const [name,setName] =useState('');

    const contractAddress="0x3DC341ecC54D166435A52E95eD086852865BBc47";
    const contractAbi=[
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "patientId",
                    "type": "uint256"
                },
                {
                    "internalType": "string",
                    "name": "name",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "diagnosis",
                    "type": "string"
                },
                {
                    "internalType": "string",
                    "name": "treatment",
                    "type": "string"
                }
            ],
            "name": "addRecord",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "provider",
                    "type": "address"
                }
            ],
            "name": "authorizedProvider",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "inputs": [],
            "name": "getOwner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "patientId",
                    "type": "uint256"
                }
            ],
            "name": "getPatientRecord",
            "outputs": [
                {
                    "components": [
                        {
                            "internalType": "uint256",
                            "name": "recordID",
                            "type": "uint256"
                        },
                        {
                            "internalType": "string",
                            "name": "patientName",
                            "type": "string"
                        },
                        {
                            "internalType": "string",
                            "name": "diagnosis",
                            "type": "string"
                        },
                        {
                            "internalType": "string",
                            "name": "treatment",
                            "type": "string"
                        },
                        {
                            "internalType": "uint256",
                            "name": "timestamp",
                            "type": "uint256"
                        }
                    ],
                    "internalType": "struct HealthCare.Records[]",
                    "name": "",
                    "type": "tuple[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ]

    useEffect(()=>{
        const connectWallet=async()=>{
            try{
            const provider=new ethers.BrowserProvider(window.ethereum)
            await provider.send("eth_requestAccounts",[]) ;
            setProvider(provider)
            const signer=await provider.getSigner();
            setSigner(signer)
            const address=await signer.getAddress();
            setAccount(address);
            console.log("addres is:",address);
            const contract=new Contract(contractAddress,contractAbi,signer)
            setContrat(contract)

            const ownerAddress=await contract.getOwner();
            setIsOwner(ownerAddress.toLowerCase() === address.toLowerCase())
            }
            catch(err){
                console.log("Please install metamask",err)
                alert("Please install metamsk")
            }
        }
        connectWallet();
    },[])

    const fetchRecords=async()=>{
        try{
            const records=await contract.getPatientRecord(patientID)  
            console.log(records.patientName)
            console.log(records.recordID)
            console.log(records.diagnosis)
            console.log(records.treatment)
            console.log(records)
            setPatientRecords(records)


        }
        catch(err){
            console.log("Error Feting Records",err);
            
        }
    }

    const addRecords=async()=>{
        try{
            const tx=await contract.addRecord(patId,name,diagnosis,treatment)
            await tx.wait()
            alert("Record added succesfully");
            
        }
        catch(err){
            console.log("Error on add record",err)
            
        }
    }

    const authorizedProvider =async() =>{
        if(isOwner){
            try{
                console.log(providerAddress)
        const tx=await contract.authorizedProvider(providerAddress)
        await tx.wait();
        alert(`provider ${providerAddress} is successfully authorised`)
        
            }
            catch(err){
                console.log("oh no",err)
            }
        }
        else{
         
        }
    }

  return (
    <div className='container'>

        <h1 className = "title">HealthCare Decentalized Application</h1>
        {account && <p className='owner-info'>Connect Account:{account} </p>}
        {isOwner && <p className='owner-info'>You Are The Owner</p>}

        <div className='form-section'>
            <h2>Fetch Records</h2>
            <input className='input-field' placeholder='Enter Patient ID' val={patientID} onChange={(e)=> setPatientID(e.target.value)}/>
            <button className='action-button' onClick={()=>fetchRecords()}>Fetch Records</button>
        </div>

        <div className='form-section'>
            <h2>AuthorizedProvider</h2>
            <input className='input-field' placeholder='Provider Account' val={providerAddress} onChange={(e)=>setProviderAddress(e.target.value)}/>
            <button className='action-button' onClick={()=>authorizedProvider()} >AuthorizedProvider</button>
        </div>

        <div className='form-section'>
            <h2>Add Records</h2>
            <input className='input-field' placeholder='Enter Patient Name' val={name} onChange={(e) => setName(e.target.value)}/>
            <input className='input-field' placeholder='Enter Patiend Id' val={patId} onChange={(e) => setPatId(e.target.value)} />
            <input className='input-field' type='text' val={diagnosis} placeholder='Enter Diagnosis' onChange={(e)=>setDiagnosis(e.target.value)}></input>
            <input className='input-field' type='text' val={treatment}placeholder='Enter TreatMent' onChange={(e) => setTreatment(e.target.value)}></input>
            <button className='action-button' onClick={()=>addRecords()}>Add Record</button>
        </div>
        <div className='records-section'>
            <h2>Patient Records</h2>
            {patientRecords.map((record, index) => (
                <div key = {index}>
                   <p>Id: {record.recordID}</p>
                   <p>Name:{record.patientName}</p>
                    <p>Diagnosis: {record.diagnosis}</p>
                    <p>Treatment: {record.treatment}</p>
                    
            </div>
            ))}
        </div>

    </div>
  )
}

export default HealthCare